import { Component, OnInit, ViewChild } from '@angular/core';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'app-delay-rule',
  templateUrl: './delay-rule.component.html',
  styleUrls: ['./delay-rule.component.scss']
})
export class DelayRuleComponent implements OnInit {
  button = {}
  date = new Date();
  durationType: any = [];
  typeDropDown:{}[]=[]
  fromvalue: number = 0;
  customDataSource: any;
  addpopup: string = ''
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang: any;

  //dropdown
  DurationWorkSystemDropDown: [];
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

  constructor(public Objects: ObjectsService, public gt: genericCustomStoreService, public translate: TranslateService) {
    gt.seturl("DelayRule");
    gt.submit();
    this.customDataSource = gt.customDataSource;
    this.setCellValueFromField = this.setCellValueFromField.bind(this);
    this.button = Objects.button;

    //get dropdown
    this.gt.getdropdowndata("DelayRule/GetDropDown","MinuteRulesTypes").subscribe((data: {}[]) => {this.typeDropDown = data})
    this.gt.getdropdowndata("DelayRule/GetDropDown","RuleDuration").subscribe((data: {}[]) => {this.durationType = data})
    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );

    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
  });

  }

  ngOnInit(): void { }
  updateRow(options: any) {
    options.newData = Object.assign(options.oldData, options.newData);
    options.newData.dateOfRegistration = this.date
  }
  onInitNewRow(e: any) {
    e.data.dateOfRegistration = this.date;
    this.addpopup = this.translate.instant('tableinfo.addbutton')
  }
  onEditingStart() {
    this.addpopup = this.translate.instant('tableinfo.editbutton')

  }

  setCellValueFromField(newdata: any, value: number, oldData: any) {
    newdata.toRule = value
    this.fromvalue = oldData.fromRule
  }


  onEditorPreparing(e: any) {
    this.gt.onEditorPreparing(e)
  }
  addrowfun(name: string) {
    return this.gt.addrow(name)
  }
}
